import axios from 'axios';
import {
  FETCH_EVENTS, FETCH_EVENT, FETCH_ACTIVE_EVENTS, FETCH_REASONS_TO_ATTEND,
  FETCH_VENUE, FETCH_VENUE_CITY_IMAGES, KNOWLEDGE_SHARING_SESSION,
  STRATEGIC_SPONSORS, PARALLEL_EVENTS, ACCOMMODATIONS, SPEAKERS_LIST,
  EXHIBITORS, MEETING_ROOMS, EVENT_PRICES,
  AWARD_PRICES, FETCH_PREVIOUS_EDITION, FETCH_EVENT_ALL_SPONSORS, PARTICIPANT_COMPANIES,
  BOOKED_TABLES,
} from './types';
import api from '../../../utils/api';

export default {
  // @Fetch all events
  async fetchEvents({ commit }, tag = '') {
    const { data } = await axios(api.events.fetch(tag));
    commit(FETCH_EVENTS, { events: data.results });
  },
  async fetchPastEvents(_, page = 1) {
    const { data } = await axios(api.events.fetchPastEvents(page));
    return data;
  },
  // @Fetch single event
  async fetchEvent({ commit }, eventId) {
    const { data } = await axios(api.events.fetchSingleEvent(eventId));
    commit(FETCH_EVENT, { event: data });
    return data;
  },
  async fetchPreviousEdition({ commit }, info) {
    const { data } = await axios(api.events.fetchPreviousEdition(info.id, info.type));
    commit(FETCH_PREVIOUS_EDITION, { prevEvent: data });
    return data;
  },
  // @Fetch single event sections
  async fetchReasonsToAttend({ commit }, eventId) {
    const { data } = await axios(api.events.fetchReasonsToAttend(eventId));
    commit(FETCH_REASONS_TO_ATTEND, { reasons: data.results });
  },
  async fetchVenue({ commit }, eventId) {
    const { data } = await axios(api.events.fetchVenue(eventId));
    commit(FETCH_VENUE, { venue: data.results[0] || {} });
  },
  async fetchAllVenues() {
    const { data } = await axios(api.events.fetchAllVenues());
    return data;
  },
  async fetchVenueCityImages({ commit }, eventId) {
    const { data } = await axios(api.events.fetchVenueCityImages(eventId));
    commit(FETCH_VENUE_CITY_IMAGES, { venueCityImages: data.results });
  },
  async fetchKnowledgeSharingSession({ commit }, eventId) {
    const { data } = await axios(api.events.knowledgeSharingSession(eventId));
    commit(KNOWLEDGE_SHARING_SESSION, { session: data.results });
  },
  async strategicSponsors({ commit }, eventId) {
    const { data } = await axios(api.events.strategicSponsors(eventId));
    commit(STRATEGIC_SPONSORS, { sponsors: data.results });
  },
  async fetchParallelEvents({ commit }, eventId) {
    const { data } = await axios(api.events.parallelEvents(eventId));
    commit(PARALLEL_EVENTS, { parallelEvents: data.results });
  },
  async fetchAccommodations({ commit }, eventId) {
    const { data } = await axios(api.events.accommodations(eventId));
    commit(ACCOMMODATIONS, { accommodations: data.results[0] });
  },
  async fetchSpeakersList({ commit }, eventId) {
    const { data } = await axios(api.events.speakersList(eventId));
    commit(SPEAKERS_LIST, { speakersList: data.results });
  },
  async fetchExhibitors({ commit }, eventId) {
    const { data } = await axios(api.events.exhibitors(eventId));
    commit(EXHIBITORS, { exhibitors: data.results });
  },
  async fetchBookedTables({ commit }, eventId) {
    const { data } = await axios(api.events.bookedTables(eventId));
    commit(BOOKED_TABLES, { bookedTables: data.results });
  },
  async fetchMeetingRooms({ commit }, eventId) {
    const { data } = await axios(api.events.meetingRooms(eventId));
    commit(MEETING_ROOMS, { meetingRooms: data.results });
  },
  async fetchMediaDocs({}, reqData) {
    const data = await axios(api.events.mediaDocs(reqData));
    return data;
  },
  async fetchParticipantMembers(_, eventId) {
    const { data } = await axios(api.events.participantMembers(eventId));
    return data;
  },
  async fetchParticipantMembersforCheck({}, eventId) {
    const { data } = await axios(api.events.participantMembers(eventId));
    return data.results;
  },
  async fetchParticipantCompanies({ commit }, fetchData) {
    const { data } = await axios(api.events.participantCompanies(fetchData));
    commit(PARTICIPANT_COMPANIES, { data });
    return data;
  },
  async fetchEventPrices({ commit }, eventId) {
    const { data } = await axios(api.events.eventPrices(eventId));
    commit(EVENT_PRICES, { eventPrices: data.results });
    return data;
  },
  async fetchAwardPrices({ commit }, awardId) {
    const { data } = await axios(api.events.awardPrices(awardId));
    commit(AWARD_PRICES, { awardPrices: data.results });
    return data;
  },
  async fetchAgenda({}, eventId) {
    const { data } = await axios(api.events.fetchAgenda(eventId));
    return data.results;
  },
  async fetchMeetingPlannerDays({}, eventId) {
    const { data } = await axios(api.events.fetchMeetingPlannerDays(eventId));
    return data.results;
  },
  async fetchAgendaMaps({}, eventId) {
    const { data } = await axios(api.events.fetchAgendaMaps(eventId));
    return data.results;
  },
  async fetchNearbyHotels({}, eventId) {
    const { data } = await axios(api.events.fetchNearbyHotels(eventId));
    return data.results;
  },
  async fetchGallery({}, eventId) {
    const { data } = await axios(api.events.fetchGallery(eventId));
    return data.results;
  },
  async eventBooking({}, bookingDetails) {
    const { data } = await axios(api.events.eventBooking(bookingDetails));
    return data;
  },
  async fetchEventsTags() {
    const { data } = await axios(api.events.fetchEventsTags());
    return data.results;
  },
  async fetchAllEvents({ commit }, tag) {
    const { data } = await axios(api.events.fetchAllEvents(tag));
    commit(FETCH_EVENTS, { events: data.results });
  },
  async getAllEvents(_, { page }) {
    const { data } = await axios(api.events.getAllEvents(page));
    return data;
  },
  async fetchActiveEvents({ commit }, tag) {
    const { data } = await axios(api.events.fetchActiveEvents(tag));
    commit(FETCH_ACTIVE_EVENTS, { activeEvents: data.results });
  },
  async fetchUpcomingEvents() {
    const { data } = await axios(api.events.fetchUpcomingEvents());
    return data.results;
  },
  async fetchEventCategories(_, eventId) {
    const { data } = await axios(api.events.fetchEventCategories(eventId));
    return data.results;
  },
  async becomePanelistOrSponsor({}, panelistSponsorData) {
    const data = await axios(api.events.becomePanelistOrSponsor(panelistSponsorData));
    return data;
  },
  async fetchEventSponsors(_, categoryId) {
    const { data } = await axios(api.events.fetchEventSponsors(categoryId));
    return data.results;
  },
  async fetchEventAllSponsors({ commit }, id) {
    const { data } = await axios(api.events.fetchEventAllSponsors(id));
    commit(FETCH_EVENT_ALL_SPONSORS, { sponsors: data.results });
    return data;
  },
  async fetchBookedEvents(_, customerId) {
    const { data } = await axios(api.events.fetchBookedEvents(customerId));
    return data.results;
  },

  async getEventParticipantMember(_, details) {
    const { data } = await axios(api.events.getEventParticipantMember(details));
    return data.results;
  },
};
